import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    sortby: 'createdAt',
    sortdir: 'DESC',
    s: undefined,
  },
  loading: false,
}

export const findoraLogsListSlice = createAppSlice({
  name: 'findoraLogsList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setLoading: create.reducer((state, { payload }) => {
      state.loading = payload
    }),
  }),
})

export const { setFetchOption, setLoading } = findoraLogsListSlice.actions

export default findoraLogsListSlice.reducer
